class ProductDesktopGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-thumb-index]'));
    this.prevBtn = this.querySelector('[data-hero-prev]');
    this.nextBtn = this.querySelector('[data-hero-next]');
    this.currentIndex = 0;

    if (this.slides.length === 0) return;

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const i = parseInt(thumb.dataset.thumbIndex, 10);
        if (!Number.isNaN(i)) this.goToSlide(i);
      });
    });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.goToSlide(this.currentIndex - 1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.goToSlide(this.currentIndex + 1));
    }

    document.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  onKeyDown(e) {
    if (!this.matches(':hover') && !this.contains(document.activeElement)) return;
    if (e.key === 'ArrowLeft') this.goToSlide(this.currentIndex - 1);
    if (e.key === 'ArrowRight') this.goToSlide(this.currentIndex + 1);
  }

  goToSlide(index) {
    const total = this.slides.length;
    if (total === 0) return;

    if (index < 0) index = total - 1;
    if (index >= total) index = 0;

    this.slides[this.currentIndex]?.classList.remove('product__hero-slide--active');
    this.thumbs[this.currentIndex]?.classList.remove('product__thumb--active');
    this.thumbs[this.currentIndex]?.setAttribute('aria-current', 'false');

    this.currentIndex = index;

    this.slides[index]?.classList.add('product__hero-slide--active');
    this.thumbs[index]?.classList.add('product__thumb--active');
    this.thumbs[index]?.setAttribute('aria-current', 'true');
    this.thumbs[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }
}

if (!customElements.get('product-desktop-gallery')) {
  customElements.define('product-desktop-gallery', ProductDesktopGallery);
}
